import { entries, notEqual, values } from "./javascript";
import { allValidations } from "./formValidations";

export const showFormErrors = (data, setData, ignore) => {
  let formErrors = {};
  entries(data).forEach(([key, value]) => {
    formErrors = {
      ...formErrors,
      ...allValidations(key, value, data, ignore),
    };
  });
  setData({ ...data, formErrors });
  return !values(formErrors).some((v) => notEqual(v, ""));
};

export const getActiveRoute = (routes, path) => {
  const allRoutes = [];

  function recurse(route) {
    allRoutes.push(route);

    if (route.subMenu) {
      route.subMenu.forEach((subRoute) => recurse(subRoute));
    }
  }
  routes.forEach((route) => recurse(route));

  return allRoutes.find((route) => route.path === path);
};
export const removeEmpty = (obj) => {
  const newObj = {};
  Object.entries(obj).forEach(([k, v]) => {
    if (v === Object(v)) {
      newObj[k] = removeEmpty(v);
    } else if (v !== "" && v !== null) {
      newObj[k] = obj[k];
    }
  });
  return newObj;
};

export const convertToFormdata = (obj) => {
  const formData = new FormData();
  Object.entries(obj).forEach(([k, v]) => {
    if (Array.isArray(v)) {
      v.forEach((item, i) => {
        Object.entries(item).forEach(([k1, v1], i1) => {
          formData.append(`${k}[${i}][${k1}]`, v1);
        });
      });
    } else {
      formData.append(k, v);
    }
  });
  return formData;
};
export const PasswordRequirement = ({ isValid, text }) => {
  const iconClass = isValid ? "pi pi-check text-sm" : "pi pi-times text-sm";
  const textColor = isValid ? "text-success" : "p-error";

  return (
    <p className={`text-sm font-normal ${textColor}`}>
      <i className={iconClass}></i>&nbsp;{text}
    </p>
  );
};

export function checkPasswordRequirement(regex, message, value) {
  return (
    <p
      className={
        regex.test(value)
          ? "text-sm text-success font-normal"
          : "text-sm p-error font-normal"
      }
    >
      <i
        className={
          regex.test(value) ? "pi pi-check text-sm" : "pi pi-times text-sm"
        }
      ></i>{" "}
      &nbsp;{message}
    </p>
  );
}

export function convertBytes(sizeInBytes) {
  const kb = 1024;
  const MB = kb * 1024;
  const GB = MB * 1024;

  if (sizeInBytes >= GB) return (sizeInBytes / GB).toFixed(2);
  else if (sizeInBytes >= MB) return (sizeInBytes / MB).toFixed(2);
  else if (sizeInBytes >= kb) return (sizeInBytes / kb).toFixed(2);
  else return sizeInBytes;
}
export function getDataSizeUnit(sizeInBytes) {
  const kb = 1024;
  const MB = kb * 1024;
  const GB = MB * 1024;

  if (sizeInBytes >= GB) return "GB";
  else if (sizeInBytes >= MB) return "MB";
  else if (sizeInBytes >= kb) return "kb";
  else return "bytes";
}
